import { useQuery } from "@tanstack/react-query"
import { queryKeys } from "../utils/constants/queryKeys"
import { endpoints } from "../utils/constants/endpoints"
import $api from "../../../services/RequestService"
import { errorHandler } from "../../../utils/helpers/errorHandler"
import { Pagination } from "../../../utils/models/paginationType"
import { AccidentModel } from "../utils/models/accidentModel"
import { ErrorRes } from "../../../utils/models/responseType"
import { addQueryParams } from "../../../utils/helpers/addQueryParams"


// get accidents
export function useGetAccidents() {
  const url = addQueryParams(endpoints.REGION_ACCIDENT_VIEW)

  return useQuery<Pagination<AccidentModel>, ErrorRes>(
    [queryKeys.REGION_ACCIDENT_VIEW, url],
    async () => {
      const res = await $api.get(url)
      return res.data.data
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      onError: errorHandler,
    },
  )
}

// get related problems
export function useGetProblemClass() {
  return useQuery<{ "id": number, "name": string}[], ErrorRes>(
    [queryKeys.ORGANIZATION_PROBLEM_CLASS],
    async () => {
      const res = await $api.get(endpoints.REGION_PROBLEM_CLASS_SELECT)
      return res.data.data
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity,
      onError: errorHandler,
    },
  )
}